import { Injectable, OnInit } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpClient,
    HttpParams
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { tap, switchMap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    constructor(private http: HttpClient) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request["url"].includes("https://s3.eu-south-1.amazonaws.com/")) {
            return next.handle(request);
        } else if (request["url"].includes("https://aquilonefarigliano.auth")){
            return next.handle(request);
        } else {
            return this.getAccessToken().pipe(
                switchMap((token) => {
                    console.log(token)
                    let with_auth_request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token.access_token}`
                        }
                    });
                    return next.handle(with_auth_request);
                }

                )
            )
        }
    }

    getAccessToken(): Observable<any> {
        let clientId = environment.clientId;
        let clientSecret = environment.clientCredential;
        let tokenEndPoint = environment.tokenEndPoint;

        let auth = btoa(clientId + ':' + clientSecret);


        const headers = {
            'Authorization': 'Basic ' + auth,
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'application/json'
        };

        const body = new HttpParams()
        .set('grant_type', 'client_credentials');

        return this.http.post<any>(tokenEndPoint, body, { headers });

    }
}
